export enum EditComponentType {
  Dtc = 'DtcEditComponent',
  ErrorMessage = 'ErrorMessageEditComponent',
  ErrorCode = 'ErrorCodeEditComponent',
  SwPartNumber = 'SwPartNumberEditComponent',
  NwNumber = 'NwNumberEditComponent',
  Project = 'Project',
}
